<template>
  <div>
    <v-card outlined>
      <v-card-title class="subtitle-1 font-weight-medium">
        {{ resultDisplay.performanceTarget.title }}<v-spacer></v-spacer>
        <performance-target-status-chip
          :status="resultDisplay.status"
          small
        ></performance-target-status-chip>
      </v-card-title>
      <v-card-subtitle>
        Ergebniswert: {{ resultDisplay.value }}
      </v-card-subtitle>
      <v-divider></v-divider>
      <v-card-text>
        <div
          v-for="(dataVariable, index) in resultDisplay.dataVariables"
          :key="index"
        >
          <v-card outlined class="mb-4">
            <v-list-item>
              <v-list-item-content>
                <v-list-item-title>
                  {{ dataVariable.variable.text }}</v-list-item-title
                >
                <v-list-item-subtitle class="font-weight-regular">
                  {{ dataVariable.sourceType.text }}
                  ({{
                    dataVariable.sourceType.description
                  }})</v-list-item-subtitle
                >
                <v-list-item-subtitle>
                  <v-chip outlined label small
                    >Ergebniswert dieser Variable:
                    {{ dataVariable.value }}</v-chip
                  >
                </v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>

            <div cols="12" v-if="dataVariable.additionalData !== null">
              <v-card-subtitle class="my-0 pt-2 pb-0"
                >Folgende Einträge wurden berücksichtigt:</v-card-subtitle
              >
              <v-list v-if="dataVariable.additionalData.length" dense>
                <v-skeleton-loader
                  v-if="dataIsLoading"
                  class="mx-auto"
                  type="text"
                ></v-skeleton-loader>
                <span
                  v-else
                  v-for="(entry, index) in dataVariable.additionalData"
                  :key="entry.id"
                >
                  <v-divider v-if="index == 0"></v-divider>
                  <v-list-item v-if="entry.type === 'dutyAttendance'">
                    <v-list-item-content>
                      <v-list-item-title>
                        {{ entry.doc.dutyReport.title }}
                      </v-list-item-title>
                      <v-list-item-subtitle>
                        <p style="line-height: 1.6" class="mb-0">
                          <v-icon small left>mdi-calendar-clock</v-icon
                          >{{
                            timestampConverter(
                              entry.doc.duration.start.timestamp
                            )
                          }}
                          bis
                          {{
                            tryToDisplayOnlyEndTime(
                              entry.doc.duration.start.timestamp,
                              entry.doc.duration.end.timestamp,
                              entry.doc.duration.end.timestamp
                            )
                          }}
                          <span
                            v-if="
                              entry.doc.attendanceStatus == '1' &&
                              entry.doc.payrollType.title
                            "
                          >
                            <br />
                            <v-icon small left>mdi-account-credit-card</v-icon
                            >{{ entry.doc.payrollType.title }}
                          </span>
                          <br />
                          <span
                            v-if="
                              entry.doc.attendanceStatus == '1' &&
                              entry.doc.assignedPosition
                            "
                          >
                            <v-icon small left>mdi-fire-truck</v-icon
                            >{{ entry.doc.assignedPosition.unit.title }} –
                            {{ entry.doc.assignedPosition.position.shortTitle }}
                            <br />
                          </span>
                          <span v-if="entry.doc.note">
                            <br />
                            <v-icon small left>mdi-card-text</v-icon
                            >{{ entry.doc.note }}
                          </span>
                        </p>
                      </v-list-item-subtitle>
                    </v-list-item-content>
                  </v-list-item>
                  <v-list-item v-else-if="entry.type === 'timeSheet'">{{
                    entry.doc.title
                  }}</v-list-item>
                  <v-divider
                    v-if="index + 1 != dataVariable.additionalData.length"
                  ></v-divider>
                </span>
              </v-list>

              <v-card-text v-else>Keine</v-card-text>
            </div>
          </v-card>
        </div>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import { db } from "@/firebase";
import PerformanceTargetStatusChip from "@/components/member-management/performance-targets/PerformanceTargetStatusChip.vue";
export default {
  name: "performance-target-personal-result-single-performance-target",
  components: { PerformanceTargetStatusChip },
  props: {
    result: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      dataIsLoading: true,
      resultDisplay: null,
    };
  },
  computed: {},
  created() {
    this.loadAdditionalData();
  },
  methods: {
    async loadAdditionalData() {
      try {
        const updatedItem = { ...this.result };
        const performanceTargetResults = updatedItem.dataVariables;

        for (const variable of performanceTargetResults) {
          if (
            variable.additionalData &&
            Array.isArray(variable.additionalData)
          ) {
            for (const additionalDataItem of variable.additionalData) {
              try {
                const basePath = db
                  .collection("organizations")
                  .doc(this.$route.params.organizationId);

                let doc;
                if (additionalDataItem.type === "dutyAttendance") {
                  doc = await basePath
                    .collection("dutyReports")
                    .doc(additionalDataItem.dutyReportId)
                    .collection("dutyAttendances")
                    .doc(additionalDataItem.id)
                    .get();
                } else if (additionalDataItem.type === "timeSheet") {
                  doc = await basePath
                    .collection("timeSheets")
                    .doc(additionalDataItem.id)
                    .get();
                }

                if (doc && doc.exists) {
                  additionalDataItem.doc = { id: doc.id, ...doc.data() };
                }
              } catch (error) {
                console.error(
                  `Error fetching additional data for ${additionalDataItem.type}/${additionalDataItem.id}:`,
                  error
                );
              }
            }
          }
        }

        this.resultDisplay = updatedItem;
      } catch (error) {
        console.error("Error loading additional data:", error);
      } finally {
        this.dataIsLoading = false;
      }
    },
    tryToDisplayOnlyEndTime(startTimestamp, endTimestamp, endTimestampString) {
      var startDate = startTimestamp.toDate();
      var endDate = endTimestamp.toDate();
      if (
        startDate.getDate() == endDate.getDate() &&
        startDate.getMonth() == endDate.getMonth() &&
        startDate.getFullYear() == endDate.getFullYear()
      ) {
        return endDate.toLocaleTimeString("de-DE", {
          hour: "2-digit",
          minute: "2-digit",
        });
      } else {
        return this.timestampConverter(endTimestampString);
      }
    },
    timestampConverter(timestamp) {
      const options = {
        weekday: "short",
        year: "2-digit",
        month: "2-digit",
        day: "2-digit",
        hour: "2-digit",
        minute: "2-digit",
      };
      return timestamp.toDate().toLocaleDateString("de-DE", options);
    },
  },
};
</script>
